/**
 * Custom Element to handle the search functionality
 * fetches newspapers based on date param in query
 * can also call the search function with a Date object
 *
 * dispatches a custom event(newspaper-search) on window with the fetched data
 */
const NODE_ENV = window.nodeEnv;
const LOCAL_DEV_NEWSPAPER_URL =
  "http://localhost:3000/newspaper/stock/9740132516173/";
class NewspaperSearch extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * check existing searchParam(query) in URL state to auto populate the search
   */
  connectedCallback() {
    const query = new URLSearchParams(window.location.search).get("query");
    if (query) {
      this.runFetch(query, true);
    }
  }

  /**
   *
   * @param {Date} value
   * pass in the Date object to search for the newspaper
   * the function formats and runs the fetch request
   */
  search(value) {
    const month = value.getMonth() + 1;
    const day = value.getDate();
    const year = value.getFullYear();

    const date = `${year}${month < 10 ? "0" + month : month}${day < 10 ? "0" + day : day}`;
    return this.runFetch(date);
  }

  /**
   *
   * @param {string} date
   * @param {boolean} query change return value based on calling context
   *
   * @description
   * date string used in the query endpoint
   * format ---> YYYYMMDD
   */
  async runFetch(date, query) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("query", date);

    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?${searchParams.toString()}`,
    );

    this.setAttribute("loading", "");
    let url = window.newspaperURL;
    console.log(
      "DEBUG: NewspaperSearch: newspaperURL, " +
        url +
        ", window.location.origin, " +
        window.location.origin,
    );
    // If no URL, fallback for tools like Postman, shopify theme dev
    // Settings are defined in settings_schema.json, but they only appear in settings_data.json after being set and saved in the theme editor, localhost is not allowed.
    if (!url && NODE_ENV === "development") {
      url = LOCAL_DEV_NEWSPAPER_URL;
      window.newspaperURL = url;
      console.log(
        "DEBUG: NewspaperSearch: newspaperURL not set, set newspaperURL, " +
          url,
      );
    }
    if (url.split("").pop() !== "/") {
      url += "/";
      window.newspaperURL = url;
    }
    return fetch(
      `${window.newspaperURL}${date}/${Shopify.locale}_${Shopify.country}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (query) {
          window.dispatchEvent(
            new CustomEvent("newspaper-search", { detail: data }),
          );
          return;
        }
        return data;
      })
      .catch((error) => {
        console.error("NewspaperSearch fetch error:", error);
        if (query) {
          window.dispatchEvent(
            new CustomEvent("newspaper-search", { detail: [] }),
          );
          return;
        }
        return [];
      })
      .finally(() => {
        this.removeAttribute("loading");
      });
  }

  disconnectedCallback() {}
}

customElements.define("newspaper-search", NewspaperSearch);
